export default "/assets/site/images/futas.jpg?2212f0e247469de88a8f2a2a27a16f55";